<template>
  <!--
    정산 확정 상태(정산계산중/미수집/검증)는 배달 플랫폼 거래내역 크롤링 윈도우(7일)로는
    안정적으로 추적할 수 없어 제거했다(정산이 7일 이후 확정되면 재크롤링 범위 밖이라 영영 미확정).
    정산 상태가 아닌 수수료 매핑 백로그(운영자용)만 노출한다.
  -->
  <div v-if="normalized.mappingBacklogCount > 0" class="settlement-badges" data-testid="settlement-badges">
    <span class="status-badge danger" :title="$t('원본 수수료 매핑이 누락된 항목')">
      <i class="el-icon-connection"></i>
      {{ $t('매핑누락') }} {{ normalized.mappingBacklogCount }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    badges: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    normalized() {
      return {
        mappingBacklogCount: this.badges.mappingBacklogCount || 0,
      }
    },
  },
}
</script>

<style scoped>
.settlement-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

.status-badge {
  display: inline-flex;
  min-height: 28px;
  align-items: center;
  gap: 5px;
  padding: 5px 9px;
  border-radius: var(--radius-sm);
  border: 1px solid transparent;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.status-badge.danger {
  color: #b51f23;
  background: #fff1f0;
  border-color: #ffccc7;
}
</style>
